import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';

import {
  I18nProvider,
} from '@uncinc/react-drupal-core';

import i18next from '../../config/i18next';
import NotFound from '../NotFound';
import VolunteerWork from '../Volunteerwork';
import Map from '../Map';

import './style.scss';
import '../../styles/main.scss';

const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Immutable.Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  });

  return (
    <I18nProvider locale={language} i18next={i18next}>
      <div className={classes} language={language}>
        <header />
        <main className="main">
          <Switch>
            <Route path="/kaart" render={() => <Map />} />
            <Route path="/ertoe-doen" render={() => <VolunteerWork />} />
            <Route render={() => (<NotFound />)} />
          </Switch>
        </main>
        <footer />
        <div id="modal-root" />
      </div>
    </I18nProvider>
  );
};

export default App;
